export default class AsyncRequestError extends Error {
    constructor({message = '', status, code = '', requestId}) {
        super(message);
        this.status = status;
        this.code = code;
        this.requestId = requestId;
    }
}
